import DatricRequests from '../datric.requests';
import {
	LiveLeadClientRow,
	LiveLeadConfig,
	LiveLeadDailyPoint,
	LiveLeadDeliveryPage,
	LiveLeadKey,
	LiveLeadStats
} from '../../../models/liveLead.model';

const requests = new DatricRequests();

export async function getLiveLeadMe(): Promise<{ config: LiveLeadConfig; stats: LiveLeadStats }> {
	return requests.get('live-lead/me');
}

export async function getLiveLeadDaily(days = 14): Promise<LiveLeadDailyPoint[]> {
	return requests.get('live-lead/me/daily', { days });
}

export async function updateLiveLeadWebhook(payload: {
	webhookUrl?: string | null;
	webhookHeaders?: Record<string, string> | null;
	rotateSecret?: boolean;
}): Promise<LiveLeadConfig> {
	return requests.put('live-lead/me/webhook', payload);
}

export async function listLiveLeadDeliveries(params: {
	page?: number;
	limit?: number;
	status?: string;
}): Promise<LiveLeadDeliveryPage> {
	return requests.get('live-lead/me/deliveries', params);
}

export async function listLiveLeadKeys(): Promise<LiveLeadKey[]> {
	return requests.get('live-lead/me/keys');
}

export async function createLiveLeadKey(name: string): Promise<LiveLeadKey> {
	return requests.post('live-lead/me/keys', { name });
}

export async function revokeLiveLeadKey(id: string): Promise<{ id: string }> {
	return requests.delete(`live-lead/me/keys/${id}`);
}

export async function listLiveLeadClients(): Promise<LiveLeadClientRow[]> {
	return requests.get('live-lead/clients');
}

export async function updateLiveLeadClient(
	userId: string,
	payload: Partial<Pick<LiveLeadClientRow, 'enabled' | 'webhookUrl' | 'delayMinutes' | 'spacingSeconds' | 'maxPerHour' | 'batchSize'>>
): Promise<LiveLeadConfig> {
	return requests.put(`live-lead/clients/${userId}`, payload);
}
